import { render, staticRenderFns } from "./Input.vue?vue&type=template&id=dc96d2a6&scoped=true&"
import script from "./Input.vue?vue&type=script&lang=js&"
export * from "./Input.vue?vue&type=script&lang=js&"
import style0 from "./Input.vue?vue&type=style&index=0&id=dc96d2a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc96d2a6",
  null
  
)

export default component.exports